const newsEventSection = $('#events-section');
const newsEventCards = newsEventSection.find('.event-card');
//const newsEventDropdown = newsEventSection.find('.events-dropdown-parent');

const addNewsEventAnimation = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #081B48 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };
  const eventBtn = newsEventSection.find('.button-parent');

  const eventTopperTL = gsap.timeline({ paused: true });
  const eventTL = gsap.timeline({ paused: true });

  eventTopperTL.add(
    animateSectionTopperIn({
      sectionParent: newsEventSection,
      gradientConfig: gradientConfig,
    }).play(),
    0
  );

  //eventTopperTL.add(elementInAnimationYWOpacity(newsEventDropdown, '100%', 0, 1, 1, 1, 0).play(), 0);
  eventTL.add(elementInAnimationYWOpacity(newsEventCards, '300%', 0, 1, 1, 0.8, 0.2, 0.1, 'start', 'pageInEasing', 'pageInEasing').play(), 0);
  addBtnAnimation(eventBtn, 50, true);

  return [eventTopperTL, eventTL];
}

const initNewsEvent = () => {
  const [eventTopperTL, eventTL] = addNewsEventAnimation();
  ScrollTrigger.create({
    trigger: newsEventSection,
    start: 'top top+=110%',
    end: 'bottom bottom',
    once: true,
    onUpdate: (self) => {
      eventTopperTL.progress(self.progress);
    },
  });

  ScrollTrigger.create({
    trigger: newsEventSection,
    start: 'top+=30% bottom',
    end: 'top top',
    once: true,
    onEnter: () => {
      eventTL.play();
    },
  });
}

addSectionObserver(newsEventSection, initNewsEvent, false);